import HelpRoundedIcon from "@mui/icons-material/HelpRounded"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"

interface Props {
    text: string
    icon?: React.ReactNode
}

const InfoTooltip = ({ text, icon }: Props) => {
    return (
        <Tooltip title={text}>
            <IconButton color="default" component="span">
                {icon ? icon : <HelpRoundedIcon />}
            </IconButton>
        </Tooltip>
    )
}

export default InfoTooltip
